module.exports = __webpack_public_path__ + "img/eye.dfbfc08d.png";